import axios from "axios";
import { useEffect, useState } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import { Marker, Popup } from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import 'react-leaflet-markercluster/styles'
import L from "leaflet";

const googleMarkerIcon = new L.Icon({
    iconUrl:
      "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png", // Google-style marker icon URL
    iconSize: [27, 40], // Adjust the size as needed
    iconAnchor: [13, 40], // Anchor point to align the icon
    popupAnchor: [0, -40], // Position of popup relative to the icon
  });

export default function Map(){
    const [pois, setPOIs] = useState([]);

    const fetchPOIs = async () => {
        try {
          const response = await axios.get('https://goldenruleismcan.org/server/get_pois.php');
          if (response.status === 200) {
            setPOIs(response.data);
          } else {
            console.error('Error fetching POIs:', response.statusText);
          }
        } catch (error) {
          console.error('Error fetching POIs:', error);
        }
    };

    useEffect(() => {
        fetchPOIs();
    }, []);


    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
    shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
    });

    return (
        <MapContainer attributionControl={false} center={[15.375592, 36.749879]} zoom={2} style={{ height: "100vh", width: "100%", backgroundColor: "white"}}>
                <TileLayer
                        url="http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
                        maxZoom={20}
                  />
            {pois.map((item, index) => (
            <Marker
                key={index}
                position={[item.latitude, item.longitude]}
                icon={googleMarkerIcon}
            >
                <Popup>
                <div style={{backgroundColor: "#d1eaee"}}>
                <strong>{item.name}</strong> <br />
                            
                <strong>Country</strong>: {item.country}
                <br />
                <strong>Message of kindness</strong>
                <br />
                  {item.commitment}
                </div>
                </Popup>
            </Marker>
            ))}
        </MapContainer>
    )
}
